export default "__VITE_ASSET__ClN8FwQh__"